import { render, staticRenderFns } from "./Top3.vue?vue&type=template&id=32f1c6b1&scoped=true&"
var script = {}
import style0 from "./Top3.vue?vue&type=style&index=0&id=32f1c6b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1c6b1",
  null
  
)

export default component.exports